/* ============================================================
   HELENA — Quiz "Encontrá tu Ritual"  ·  Shopify build
   - Ritual = edad + tipo de piel (tabla ID y RITUALES)
   - Tarjetas alimentadas por metafields (quiz_activos / quiz_modo_de_uso / quiz_momento)
   - Ampolla Longevity adicional según beneficio principal
   - Carrito 100% AJAX (/cart/add.js)
   ============================================================ */
(function () {
  "use strict";

  var ROOT = document.getElementById("helena-quiz");
  if (!ROOT) return;

  var $  = function (s, r) { return (r || ROOT).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || ROOT).querySelectorAll(s)); };

  /* ---------------------------------------------------------
     ICONS
     --------------------------------------------------------- */
  var I = {
    arrowR: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    arrowL: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M11 6l-6 6 6 6"/></svg>',
    radio: '<svg viewBox="0 0 24 24" fill="none"><circle class="ring" cx="12" cy="12" r="9.5" stroke="#ddd0c4" stroke-width="1.3"/><circle class="tick" cx="12" cy="12" r="5" fill="currentColor"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none"><rect class="ring" x="3" y="3" width="18" height="18" rx="6" stroke="#ddd0c4" stroke-width="1.3"/><path class="tick" d="M7.5 12.4l3 3 6-6.4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>',
    help: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9.5"/><path d="M9.4 9.2a2.6 2.6 0 015.1.7c0 1.7-2.5 2.1-2.5 3.8"/><circle cx="12" cy="17" r="0.6" fill="currentColor"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    sun: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M2 12h2M20 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4"/></svg>',
    moon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 14.5A8 8 0 119.5 4a6.4 6.4 0 0010.5 10.5z"/></svg>',
    droplet: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3.2C9 7 6 10 6 13.5a6 6 0 0012 0C18 10 15 7 12 3.2z"/></svg>',
    leaf: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 19c0-7 5-13 14-14 .5 8-4.5 14-14 14z"/><path d="M5 19c3-4 6-6 9-7"/></svg>',
    bag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 016 0v2"/></svg>',
    checkOnly: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4 4 10-10"/></svg>',
    chevron: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>',
    redo: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 5v5h5"/><path d="M4 10a8 8 0 113 9"/></svg>',
    star: '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M12 3.2l2.5 5.5 6 .6-4.5 4 1.3 5.9L12 16.9 6.7 19.2 8 13.3l-4.5-4 6-.6L12 3.2z"/></svg>',
    snow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v20M2 12h20M5 5l14 14M19 5L5 19M12 6l-2.4-2.4M12 6l2.4-2.4M12 18l-2.4 2.4M12 18l2.4 2.4M6 12l-2.4-2.4M6 12l-2.4 2.4M18 12l2.4-2.4M18 12l2.4 2.4"/></svg>'
  };

  /* ---------------------------------------------------------
     PRODUCT DATA (server-rendered by Liquid) -> map by id
     --------------------------------------------------------- */
  var PRODUCTS = {};
  (function loadProducts() {
    var el = document.getElementById("quiz-products-data");
    if (!el) return;
    var arr = [];
    try { arr = JSON.parse(el.textContent || "[]"); } catch (e) { arr = []; }
    arr.forEach(function (p) { if (p && p.id != null) PRODUCTS[String(p.id)] = p; });
  })();
  function prod(id) { return PRODUCTS[String(id)] || null; }

  var MONEY_FORMAT = window.QUIZ_MONEY_FORMAT || "${{amount}}";
  function money(cents) {
    if (cents == null || isNaN(cents)) return "";
    function fmt(num, precision, thousands, decimal) {
      num = (num / 100).toFixed(precision);
      var parts = num.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : "";
      return dollars + cents2;
    }
    return MONEY_FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, name) {
      switch (name) {
        case "amount":                                   return fmt(cents, 2, ",", ".");
        case "amount_no_decimals":                       return fmt(cents, 0, ",", ".");
        case "amount_with_comma_separator":              return fmt(cents, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator":  return fmt(cents, 0, ".", ",");
        case "amount_with_apostrophe_separator":         return fmt(cents, 2, "'", ".");
        default:                                         return fmt(cents, 2, ",", ".");
      }
    });
  }

  /* ---------------------------------------------------------
     CONFIG editable (textos del customizer). Claves internas fijas.
     --------------------------------------------------------- */
  var CFG = {};
  (function loadConfig() {
    var el = document.getElementById("quiz-config");
    if (!el) return;
    try { CFG = JSON.parse(el.textContent || "{}") || {}; } catch (e) { CFG = {}; }
  })();
  // Mezcla por índice: mantiene la clave interna (v), pisa label/desc desde CFG.
  function mergeByIndex(defs, arr) {
    if (!Array.isArray(arr)) return defs;
    return defs.map(function (d, i) {
      var o = arr[i] || {};
      return {
        v: d.v,
        label: (o.label != null && o.label !== "") ? o.label : (d.label || d.v),
        desc: (o.desc != null && o.desc !== "") ? o.desc : d.desc
      };
    });
  }
  function cfgUi(key, fallback) {
    return (CFG.ui && CFG.ui[key] != null && CFG.ui[key] !== "") ? CFG.ui[key] : fallback;
  }

  /* ---------------------------------------------------------
     QUIZ DATA
     --------------------------------------------------------- */
  var AGES = mergeByIndex([
    { v: "16-24", label: "16 a 24" },
    { v: "25-34", label: "25 a 34" },
    { v: "35-44", label: "35 a 44" },
    { v: "45+",   label: "45 o más" }
  ], CFG.ages);
  var SKIN_TYPES = mergeByIndex([
    { v: "MIXTA",  label: "MIXTA",  desc: "Zona T con brillo, mejillas equilibradas o secas." },
    { v: "OLEOSA", label: "OLEOSA", desc: "Brillo general y tendencia a poros marcados." },
    { v: "SECA",   label: "SECA",   desc: "Tirantez, falta de confort y aspecto apagado." }
  ], CFG.skins);
  var SKIN_CHARS = mergeByIndex([
    { v: "Sensible", label: "Sensible", desc: "Reacciona con facilidad, se enrojece." },
    { v: "Madura",   label: "Madura",   desc: "Busca firmeza y densidad." }
  ], CFG.chars);
  var BENEFITS = mergeByIndex([
    { v: "Iluminar",       label: "Iluminar",       desc: "Más luz y vitalidad, un rostro despierto." },
    { v: "Hidratar",       label: "Hidratar",       desc: "Confort y agua para una piel mullida." },
    { v: "Calmar",         label: "Calmar",         desc: "Menos rojeces y sensación de irritación." },
    { v: "Reducir poros",  label: "Reducir poros",  desc: "Textura más pareja y prolija." },
    { v: "Firmeza",        label: "Firmeza",        desc: "Piel más tensa y con densidad." },
    { v: "Antioxidante",   label: "Antioxidante",   desc: "Defensa frente al sol y la polución." },
    { v: "Matificar",      label: "Matificar",      desc: "Control del brillo a lo largo del día." },
    { v: "Uniformar tono", label: "Uniformar tono", desc: "Manchas y marcas más disimuladas." }
  ], CFG.benefits);
  var BENEFIT_MAX = 3;

  var TEMP_ZONES = [
    { id: "frio",     max: 10,       label: "Frío",     blurb: "clima frío" },
    { id: "templado", max: 30,       label: "Templado", blurb: "clima templado" },
    { id: "calido",   max: Infinity, label: "Cálido",   blurb: "clima cálido" }
  ];
  function tempZone(t) {
    if (t == null) return null;
    for (var i = 0; i < TEMP_ZONES.length; i++) if (t < TEMP_ZONES[i].max) return TEMP_ZONES[i];
    return TEMP_ZONES[TEMP_ZONES.length - 1];
  }

  /* --- Product IDs (ID y RITUALES.txt) --- */
  var P = {
    AGUA_MICELAR: "9018846183679",
    CREMA_LIMPIEZA: "9018819576063",
    SERUM_ESENCIAL: "9018878263551",
    SERUM_OJOS: "9018793263359",
    CREMA_DIA: "9007071494399",
    CREMA_NOCHE: "9018749616383"
  };

  /* --- Rituales: edad + tipo de piel -> pasos --- */
  // Cada paso: { role, ids:[...] }
  var R_16_24 = {
    duration: "3 minutos", durMeta: "incluye 1 minuto de respiración consciente",
    steps: [ { role: "Limpieza", ids: [P.AGUA_MICELAR, P.CREMA_LIMPIEZA] } ]
  };
  var R_45 = {
    duration: "6 a 7 minutos", durMeta: "incluye 1 minuto de respiración consciente",
    steps: [
      { role: "Limpieza", ids: [P.AGUA_MICELAR] },
      { role: "Limpieza y Humectación", ids: [P.CREMA_LIMPIEZA] },
      { role: "Hidratación y Nutrición", ids: [P.SERUM_ESENCIAL] },
      { role: "Lifting", ids: [P.SERUM_OJOS] },
      { role: "Hidratación y Protección / Detox", ids: [P.CREMA_DIA, P.CREMA_NOCHE] }
    ]
  };
  var RITUALS = {
    "16-24": { _: R_16_24 },
    "45+":   { _: R_45 },
    "25-34": {
      MIXTA: { duration: "3 a 5 minutos", durMeta: "incluye 1 minuto de respiración consciente", steps: [
        { role: "Limpieza", ids: [P.AGUA_MICELAR, P.CREMA_LIMPIEZA] },
        { role: "Hidratación y Nutrición", ids: [P.SERUM_ESENCIAL] },
        { role: "Detox y Prevención", ids: [P.CREMA_NOCHE] }
      ]},
      OLEOSA: { duration: "3 a 5 minutos", durMeta: "incluye 1 minuto de respiración consciente", steps: [
        { role: "Limpieza", ids: [P.AGUA_MICELAR] },
        { role: "Hidratación y Nutrición", ids: [P.SERUM_ESENCIAL] },
        { role: "Detox y Prevención", ids: [P.CREMA_NOCHE] }
      ]},
      SECA: { duration: "3 a 5 minutos", durMeta: "incluye 1 minuto de respiración consciente", steps: [
        { role: "Limpieza y Humectación", ids: [P.CREMA_LIMPIEZA] },
        { role: "Lifting", ids: [P.SERUM_OJOS] },
        { role: "Detox y Prevención", ids: [P.CREMA_NOCHE] }
      ]}
    },
    "35-44": {
      MIXTA: { duration: "3 a 4 minutos", durMeta: "incluye 1 minuto de respiración consciente", steps: [
        { role: "Limpieza", ids: [P.AGUA_MICELAR, P.CREMA_LIMPIEZA] },
        { role: "Hidratación y Nutrición", ids: [P.SERUM_ESENCIAL] },
        { role: "Lifting", ids: [P.SERUM_OJOS] },
        { role: "Hidratación y Protección / Detox", ids: [P.CREMA_DIA, P.CREMA_NOCHE] }
      ]},
      OLEOSA: { duration: "3 a 4 minutos", durMeta: "incluye 1 minuto de respiración consciente", steps: [
        { role: "Limpieza", ids: [P.AGUA_MICELAR] },
        { role: "Hidratación y Nutrición", ids: [P.SERUM_ESENCIAL] },
        { role: "Lifting / Detox", ids: [P.SERUM_OJOS, P.CREMA_NOCHE] }
      ]},
      SECA: { duration: "3 a 4 minutos", durMeta: "incluye 1 minuto de respiración consciente", steps: [
        { role: "Limpieza", ids: [P.AGUA_MICELAR, P.CREMA_LIMPIEZA] },
        { role: "Hidratación y Nutrición", ids: [P.SERUM_ESENCIAL] },
        { role: "Lifting", ids: [P.SERUM_OJOS] },
        { role: "Hidratación y Protección / Detox", ids: [P.CREMA_DIA, P.CREMA_NOCHE] }
      ]}
    }
  };
  function pickRitual() {
    var byAge = RITUALS[state.age] || RITUALS["25-34"];
    return byAge._ || byAge[state.skinType] || byAge.MIXTA;
  }

  /* --- Momento (AM/PM) FIJO por ritual para los 4 productos variables.
     Cremas (día/noche) y ampoules NO se listan aquí: usan el metafield quiz_momento. --- */
  var MOMENTO_FIX = {
    "16-24":        { "9018846183679": ["AM"],       "9018819576063": ["PM"] },
    "25-34_MIXTA":  { "9018846183679": ["AM"],       "9018878263551": ["AM"],       "9018819576063": ["PM"] },
    "25-34_OLEOSA": { "9018846183679": ["AM","PM"],  "9018878263551": ["AM","PM"] },
    "25-34_SECA":   { "9018819576063": ["AM","PM"],  "9018793263359": ["AM","PM"] },
    "35-44_MIXTA":  { "9018846183679": ["AM"],       "9018819576063": ["PM"],       "9018878263551": ["AM","PM"], "9018793263359": ["AM","PM"] },
    "35-44_OLEOSA": { "9018846183679": ["AM"],       "9018878263551": ["AM"],       "9018793263359": ["AM","PM"] },
    "35-44_SECA":   { "9018846183679": ["AM"],       "9018819576063": ["PM"],       "9018878263551": ["AM","PM"], "9018793263359": ["AM","PM"] },
    "45+":          { "9018846183679": ["AM","PM"],  "9018819576063": ["AM","PM"],  "9018878263551": ["AM","PM"], "9018793263359": ["AM","PM"] }
  };
  function ritualKey() {
    if (state.age === "16-24") return "16-24";
    if (state.age === "45+") return "45+";
    return (state.age || "25-34") + "_" + (state.skinType || "MIXTA");
  }
  function momentoFix(p) {
    if (!p) return null;
    var fix = MOMENTO_FIX[ritualKey()];
    return (fix && fix[String(p.id)]) ? fix[String(p.id)].slice() : null;
  }

  // Copy por rol de paso (default; el customizer puede pisar título y texto)
  var STEP_COPY = {
    "Limpieza": "El primer gesto: retirá impurezas y restos del día para que el resto del ritual penetre de verdad.",
    "Limpieza y Humectación": "Limpieza suave que respeta el confort de la piel y deja el rostro listo, sin tirantez.",
    "Hidratación y Nutrición": "El corazón del ritual: nutre e hidrata en profundidad capa tras capa, con uso constante.",
    "Detox y Prevención": "El paso de noche: la piel se repara mientras dormís y previene los signos del tiempo.",
    "Lifting": "Trabajo de firmeza y mirada: redensifica y aporta tono donde la piel más lo necesita.",
    "Lifting / Detox": "Firmeza de día y reparación de noche en un mismo gesto enfocado.",
    "Hidratación y Protección / Detox": "Cierra el ritual: protección e hidratación de día, regeneración de noche."
  };
  function stepCfg(role) { return (CFG.steps && CFG.steps[role]) || {}; }
  function stepTitle(role) { var c = stepCfg(role); return (c.title != null && c.title !== "") ? c.title : role; }
  function stepCopy(role) { var c = stepCfg(role); return (c.copy != null && c.copy !== "") ? c.copy : (STEP_COPY[role] || ""); }

  /* Ampollas Longevity (adicionales) */
  var AMPOULE_VARIANTS = {
    glow:        { key: "glow",        id: "9364121387263", ritual: "Longevity Glow",           blurb: "luminosidad y uniformidad" },
    hydration:   { key: "hydration",   id: "9364181975295", ritual: "Longevity Deep Hydration", blurb: "hidratación profunda y confort" },
    antioxidant: { key: "antioxidant", id: "9364184465663", ritual: "Longevity Antioxidant",    blurb: "defensa antioxidante y firmeza" }
  };
  /* Recomendación de ampollas por EDAD + TIPO DE PIEL + TEMPERATURA (reglas de la clienta).
     Devuelve 1 o 2 variantes. */
  function recommendedAmpoules() {
    var age = state.age, skin = state.skinType, t = state.temp;
    var set = {};
    function add(k) { set[k] = true; }
    function del(k) { delete set[k]; }

    // 1) Base por edad/piel
    if (age === "16-24") {
      add("glow");                                   // Glow: jóvenes
    } else {
      add("antioxidant");                            // Antioxidante: 25+ todo tipo
      if (age === "35-44") { if (skin === "MIXTA" || skin === "SECA") add("hydration"); } // Deep Hydration 35+ mixta/seca
      else if (age === "45+") { add("hydration"); }  // 45+ todo tipo (incluye oleosa)
    }

    // 2) Temperatura
    if (t != null) {
      if (t < 10) add("hydration");                  // Deep Hydration: < 10°
      if (t > 30) add("antioxidant");                // Antioxidante: > 30°
    }

    // 3) Casos especiales
    if (age === "16-24" && t != null && t > 30) { del("glow"); add("antioxidant"); } // joven + calor -> Antiox (no Glow)
    if (t != null && t < 10 && (age === "25-34" || (age === "35-44" && skin === "OLEOSA"))) {
      add("antioxidant"); add("hydration");          // frío: Deep Hydration además de Antiox
    }

    var order = ["glow", "hydration", "antioxidant"];
    return order.filter(function (k) { return set[k]; }).map(function (k) { return AMPOULE_VARIANTS[k]; });
  }
  function ampSelected(key) { return state.ampSel[key] !== false; } // default: recomendada = tildada

  /* ---------------------------------------------------------
     STATE
     --------------------------------------------------------- */
  var KEY = "helena_quiz_state_v2";
  function defaultState() {
    return { screen: "hero", age: null, temp: null, skinType: null, skinChar: null, benefits: [], ampSel: {} };
  }
  var state = load();
  function load() {
    try { var s = JSON.parse(localStorage.getItem(KEY)); if (s && typeof s === "object") return Object.assign(defaultState(), s); } catch (e) {}
    return defaultState();
  }
  function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }

  /* ---------------------------------------------------------
     SCREEN FLOW
     --------------------------------------------------------- */
  var ORDER = ["hero", "step1", "step2", "step3", "results"];
  var STEP_NUM = { step1: 1, step2: 2, step3: 3 };
  var STEP_TOTAL = 3;
  var animating = false;

  function go(target, dir) {
    if (animating || target === state.screen) return;
    animating = true;
    var cur = $('.screen[data-screen="' + state.screen + '"]');
    var next = $('.screen[data-screen="' + target + '"]');
    var progress = $("#progress");
    progress.classList.add("loading");
    if (cur) cur.classList.add("leaving");
    setTimeout(function () {
      if (cur) cur.classList.remove("active", "leaving");
      state.screen = target;
      save();
      ROOT.setAttribute("data-screen", target);
      syncChrome();
      next.classList.add("active");
      var body = next.querySelector(".screen-body, .results-scroll, .hero");
      if (body && body.scrollTo) body.scrollTo({ top: 0 });
      setTimeout(function () { progress.classList.remove("loading"); animating = false; }, 240);
      if (target === "results") buildResults();
      setTimeout(updateScrollHint, 80);
    }, 480);
  }
  function nextOf(s) { var i = ORDER.indexOf(s); return ORDER[Math.min(i + 1, ORDER.length - 1)]; }
  function prevOf(s) { var i = ORDER.indexOf(s); return ORDER[Math.max(i - 1, 0)]; }

  function syncChrome() {
    var s = state.screen;
    var isStep = s in STEP_NUM;
    var progress = $("#progress");
    var footer = $("#footer");
    progress.classList.toggle("hidden", !isStep);
    footer.classList.toggle("hidden", !isStep);
    if (isStep) {
      var n = STEP_NUM[s];
      $("#progress-fill").style.width = (n / STEP_TOTAL * 100) + "%";
      $("#step-count").textContent = "Paso " + n + " de " + STEP_TOTAL;
    }
    $("#step-count").style.visibility = isStep ? "visible" : "hidden";
    updateFooter();
  }

  function isValid(s) {
    switch (s) {
      case "step1": return !!state.age;                 // edad ahora obligatoria
      case "step2": return !!state.skinType;            // característica opcional
      case "step3": return state.benefits.length >= 1;  // hasta 3
      default: return true;
    }
  }
  function updateFooter() {
    var s = state.screen;
    if (!(s in STEP_NUM)) return;
    var cont = $("#btn-continue");
    cont.disabled = !isValid(s);
    cont.querySelector(".lbl").textContent = (s === "step3") ? cfgUi("continueLast", "Ver mi ritual") : cfgUi("continue", "Continuar");
  }

  /* ---------------------------------------------------------
     RENDER — option groups
     --------------------------------------------------------- */
  function optRow(group, item, opts) {
    opts = opts || {};
    var b = document.createElement("button");
    b.className = "opt" + (opts.tri ? " opt-tri" : "");
    b.type = "button";
    b.dataset.group = group;
    b.dataset.val = item.v;
    b.setAttribute("role", opts.multi ? "checkbox" : "radio");
    b.setAttribute("aria-checked", "false");
    if (opts.tri) {
      b.innerHTML =
        '<div class="tri-top"><span class="tri-name">' + (item.label || item.v) + '</span>' +
        '<span class="marker">' + I.radio + '</span></div>' +
        '<span class="tri-desc">' + (item.desc || "") + '</span>';
    } else {
      var sub = item.sub ? '<span class="label-sub">' + item.sub + '</span>'
        : (item.desc ? '<span class="label-sub">' + item.desc + '</span>' : "");
      b.innerHTML =
        '<span class="marker">' + (opts.multi ? I.check : I.radio) + '</span>' +
        '<span class="label"><span class="label-strong">' + (item.label || item.v) + '</span>' + sub + '</span>';
    }
    return b;
  }
  function buildSingle(containerSel, group, items, opts) {
    opts = opts || {};
    var wrap = $(containerSel);
    wrap.innerHTML = "";
    items.forEach(function (it) {
      var row = optRow(group, it, opts);
      row.addEventListener("click", function () {
        if (opts.multi) {
          var arr = state[opts.field];
          var i = arr.indexOf(it.v);
          if (i >= 0) arr.splice(i, 1);
          else { if (arr.length >= opts.max) return; arr.push(it.v); }
        } else if (opts.deselectable && state[opts.field] === it.v) {
          state[opts.field] = null;
        } else {
          state[opts.field] = it.v;
        }
        save();
        refreshGroup(group);
        updateFooter();
      });
      wrap.appendChild(row);
    });
    refreshGroup(group);
  }
  var GROUP_FIELD = { age: "age", skinType: "skinType", skinChar: "skinChar", benefits: "benefits" };
  function refreshGroup(group) {
    var field = GROUP_FIELD[group];
    var val = state[field];
    $$('[data-group="' + group + '"]').forEach(function (el) {
      var on = Array.isArray(val) ? val.indexOf(el.dataset.val) >= 0 : val === el.dataset.val;
      el.classList.toggle("selected", on);
      el.setAttribute("aria-checked", on ? "true" : "false");
    });
    if (group === "benefits") {
      var arr = state.benefits;
      $$('[data-group="benefits"]').forEach(function (el) {
        var on = arr.indexOf(el.dataset.val) >= 0;
        el.classList.toggle("disabled", !on && arr.length >= BENEFIT_MAX);
      });
      var meta = $("#benefit-count");
      if (meta) {
        var tpl = cfgUi("benefitCounter", "Seleccionaste {n} de {max}");
        meta.innerHTML = tpl.replace("{n}", "<b>" + arr.length + "</b>").replace("{max}", BENEFIT_MAX);
      }
    }
  }

  /* ---------------------------------------------------------
     DRAWER
     --------------------------------------------------------- */
  function openDrawer() { $("#scrim").classList.add("open"); $("#drawer").classList.add("open"); document.body.style.overflow = "hidden"; }
  function closeDrawer() { $("#scrim").classList.remove("open"); $("#drawer").classList.remove("open"); document.body.style.overflow = ""; }

  /* ---------------------------------------------------------
     TEMPERATURE slider
     --------------------------------------------------------- */
  var TEMP_THEME = {
    frio:     { ic: function () { return I.snow; }, color: "#5b8fb4" },
    templado: { ic: function () { return I.leaf; }, color: "#7e9a6e" },
    calido:   { ic: function () { return I.sun;  }, color: "#d07a52" }
  };
  function renderTemp(val, touched) {
    var block = $("#temp-block");
    if (!block) return;
    var z = tempZone(val) || TEMP_ZONES[1];
    var theme = TEMP_THEME[z.id];
    block.style.setProperty("--temp-accent", theme.color);
    block.classList.toggle("untouched", !touched);
    $("#temp-ic").innerHTML = theme.ic();
    $("#temp-val").textContent = val + "°";
    $("#temp-zone").textContent = z.label;
  }
  function resetTemp() { var range = $("#temp-range"); if (range) range.value = 20; renderTemp(20, false); }
  function wireTemp() {
    var range = $("#temp-range");
    if (!range) return;
    range.addEventListener("input", function () {
      var v = parseInt(range.value, 10);
      state.temp = v; save(); renderTemp(v, true);
    });
    if (state.temp != null) { range.value = state.temp; renderTemp(state.temp, true); }
    else renderTemp(20, false);
  }

  /* ---------------------------------------------------------
     RESULTS
     --------------------------------------------------------- */
  function listToText(arr) {
    if (arr.length === 1) return arr[0];
    if (arr.length === 2) return arr[0] + " y " + arr[1];
    return arr.slice(0, -1).join(", ") + " y " + arr[arr.length - 1];
  }
  function volFromTitle(title) {
    if (!title) return "";
    var m = title.match(/\(([^)]*\b(?:ml|g|gr|un|x\s?\d+)[^)]*)\)/i);
    return m ? m[1].trim() : "";
  }
  function cleanTitle(title) { return (title || "").replace(/\s*\([^)]*\)\s*$/, "").trim(); }
  function momentoArr(p) {
    var fixed = momentoFix(p);        // AM/PM fijo por ritual (4 productos variables)
    if (fixed) return fixed;
    var m = p && p.momento;           // resto (cremas, ampoules): metafield quiz_momento
    if (Array.isArray(m)) return m.map(function (x) { return String(x).toUpperCase().trim(); });
    if (typeof m === "string" && m) return [m.toUpperCase().trim()];
    return [];
  }
  function activosText(p) {
    var a = p && p.activos;
    if (Array.isArray(a)) return a.filter(Boolean).join(" · ");
    if (typeof a === "string") return a;
    return "";
  }
  function whenChips(mom) {
    var h = "";
    if (mom.indexOf("AM") >= 0) h += '<span class="when-chip am" title="Mañana">' + I.sun + '</span>';
    if (mom.indexOf("PM") >= 0) h += '<span class="when-chip" title="Noche">' + I.moon + '</span>';
    return h;
  }

  // Construye lista de bloques: pasos del ritual + ampolla recomendada entre paso 1 y 2
  function buildBlocks() {
    var ritual = pickRitual();
    var blocks = [];
    ritual.steps.forEach(function (step, idx) {
      blocks.push({ kind: "step", role: step.role, ids: step.ids });
      if (idx === 0 && recommendedAmpoules().length) {
        blocks.push({ kind: "reco" });
      }
    });
    return { ritual: ritual, blocks: blocks };
  }

  function recoLine(v) {
    var z = tempZone(state.temp);
    var skin = (state.skinType || "").toLowerCase();
    var skinBit = skin ? "tu piel <b>" + skin + "</b>" : "tu piel";
    if (z && z.id === "frio")
      return "Por el <b>clima frío</b> de tu zona y " + skinBit + ", sumamos la <b>" + v.ritual + "</b>: un extra de " + v.blurb + " para los días de baja temperatura.";
    if (z && z.id === "calido")
      return "Con el <b>clima cálido</b> de tu zona y " + skinBit + ", la <b>" + v.ritual + "</b> aporta " + v.blurb + " sin recargar, ideal cuando sube la temperatura.";
    if (z && z.id === "templado")
      return "Para el <b>clima templado</b> de tu zona y " + skinBit + ", la <b>" + v.ritual + "</b> es el plus perfecto de " + v.blurb + ".";
    return "Para " + skinBit + ", sumamos la <b>" + v.ritual + "</b>: un plus de " + v.blurb + " pensado a tu medida.";
  }

  function productCardHTML(p, role, isReco) {
    if (!p) return "";
    var mom = momentoArr(p);
    // Imágenes: preferir metafield custom.quiz_imagenes; si vacío, fotos del producto.
    var imgs = (p.imagenes && p.imagenes.length) ? p.imagenes
      : (p.images && p.images.length ? p.images : (p.featured ? [p.featured] : []));
    var galleryInner = imgs.length
      ? imgs.map(function (src) { return '<img src="' + src + '" alt="" loading="lazy" draggable="false">'; }).join("")
      : '<img src="" alt="">';
    var dots = imgs.map(function () { return "<i></i>"; }).join("");
    var single = imgs.length <= 1 ? " single" : "";
    var cat = isReco ? ((CFG.reco && CFG.reco.cat) || "Tratamiento intensivo") : role;
    var vol = volFromTitle(p.title);
    var actives = activosText(p);
    var modo = (typeof p.modo === "string" && p.modo) ? p.modo
      : (mom.indexOf("AM") >= 0 && mom.indexOf("PM") >= 0) ? "Mañana y noche, sobre piel limpia."
      : mom.indexOf("AM") >= 0 ? "A la mañana, como primer gesto del día."
      : mom.indexOf("PM") >= 0 ? "A la noche, antes de dormir." : "";
    var momTxt = mom.indexOf("AM") >= 0 && mom.indexOf("PM") >= 0 ? "AM · PM"
      : mom.indexOf("AM") >= 0 ? "AM" : mom.indexOf("PM") >= 0 ? "PM" : "";

    var specRows = "";
    if (actives) specRows += "<div><dt>Activos</dt><dd>" + actives + "</dd></div>";
    if (modo)    specRows += "<div><dt>Modo de uso</dt><dd>" + modo + "</dd></div>";
    if (momTxt)  specRows += "<div><dt>Momento</dt><dd>" + momTxt + "</dd></div>";

    var descr = (typeof p.descripcion === "string" && p.descripcion.trim()) ? p.descripcion.trim() : "";
    var descrHTML = descr ? '<p class="acc-text">' + descr.replace(/\n/g, "<br>") + '</p>' : "";
    var hasAcc = descrHTML || specRows;
    var acc = hasAcc
      ? '<button class="acc-toggle" type="button" aria-expanded="false"><span class="acc-lbl">Ver descripción</span><span class="acc-ic">' + I.chevron + '</span></button>' +
        '<div class="acc-panel"><div class="acc-inner">' +
          descrHTML +
          (specRows ? '<dl class="acc-spec">' + specRows + '</dl>' : "") +
        '</div></div>'
      : "";

    var hook = (typeof p.hook === "string" && p.hook.trim()) ? p.hook.trim() : "";
    var hookLine = hook ? '<p class="phook">' + hook + '</p>' : "";

    var priceLine = p.available
      ? '<div class="p-meta"><span class="price">' + (money(p.priceCents) || p.price || "") + '</span>' + (vol ? '<span class="vol">' + vol + '</span>' : "") + '</div>'
      : '<div class="p-meta"><span class="p-soldout">Sin stock</span>' + (vol ? '<span class="vol">' + vol + '</span>' : "") + '</div>';

    return '<article class="product' + (isReco ? " product-reco" : "") + '">' +
      '<div class="p-gallery' + single + '">' +
        '<div class="p-track">' + galleryInner + '</div>' +
        '<button class="g-arrow prev" type="button" aria-label="Anterior">' + I.arrowL + '</button>' +
        '<button class="g-arrow next" type="button" aria-label="Siguiente">' + I.arrowR + '</button>' +
        '<div class="g-dots">' + dots + '</div>' +
      '</div>' +
      '<div class="p-info">' +
        '<div class="p-head"><div class="p-headl">' +
          '<span class="cat">' + cat + '</span>' +
          '<h3 class="pname">' + cleanTitle(p.title) + '</h3>' +
        '</div><div class="when">' + whenChips(mom) + '</div></div>' +
        hookLine +
        priceLine +
        acc +
      '</div>' +
    '</article>';
  }

  function buildResults() {
    var data = buildBlocks();
    var ritual = data.ritual;
    var RC = CFG.reco || {};

    // #result-name lo renderiza el customizer (setting res_name); no lo pisamos.

    // why
    var skinTxt = (state.skinType || "equilibrada").toLowerCase();
    var charBit = state.skinChar ? ", de carácter <b>" + state.skinChar.toLowerCase() + "</b>" : "";
    var ageBit = state.age ? " con una edad percibida de " + state.age.replace("-", " a ").replace("+", " o más") + " años" : "";
    var z = tempZone(state.temp);
    var tempBit = z ? " y un <b>" + z.blurb + "</b> de " + state.temp + "°" : "";
    var benBit = state.benefits.length
      ? "Lo enfocamos en " + listToText(state.benefits.map(function (b) { return b.toLowerCase(); })) + "."
      : "Un gesto simple, corto y enfocado.";
    $("#result-why").innerHTML =
      "Para una piel <b>" + skinTxt + "</b>" + charBit + ageBit + tempBit + ", " +
      "compusimos un ritual de bienestar pensado a tu medida. " + benBit + " " +
      "Una cápsula armónica que se repite en la mañana y en la noche.";

    // tags
    var tags = [];
    if (state.skinType) tags.push("Piel " + state.skinType.toLowerCase());
    if (state.skinChar) tags.push(state.skinChar);
    if (z) tags.push(z.label + " · " + state.temp + "°");
    state.benefits.slice(0, 3).forEach(function (b) { tags.push(b); });
    $("#result-tags").innerHTML = tags.map(function (t) { return '<span class="tag">' + t + "</span>"; }).join("");

    // time
    $("#result-time-val").innerHTML = ritual.duration + " <span>(" + cfgUi("timeMeta", ritual.durMeta) + ")</span>";

    // blocks
    var grid = $("#product-grid");
    grid.innerHTML = "";
    var total = 0, stepNo = 0;

    data.blocks.forEach(function (blk) {
      if (blk.kind === "reco") {
        recommendedAmpoules().forEach(function (v) {
          var amp = prod(v.id);
          if (!amp) return; // ampolla no cargada en el selector -> omitir
          var checked = ampSelected(v.key);
          var block = document.createElement("div");
          block.className = "step-block is-reco";
          block.innerHTML =
            '<div class="reco-banner">' +
              '<span class="reco-tag"><span class="reco-star">' + I.star + '</span><span class="reco-tag-txt">' + (RC.tag || "Una recomendación para vos") + '</span></span>' +
              '<span class="reco-between">' + (RC.between || "Un extra opcional · entre el paso 1 y el paso 2") + '</span>' +
              '<p class="reco-line">' + recoLine(v) + '</p>' +
            '</div>' +
            '<label class="reco-check"><input type="checkbox" data-amp="' + v.key + '"' + (checked ? " checked" : "") + ' />' +
              '<span class="reco-box">' + I.checkOnly + '</span>' +
              '<span class="reco-check-lbl">' + (RC.check || "Sí, lo quiero en mi ritual") + '</span></label>' +
            '<div class="step-products" style="margin-top:16px;">' + productCardHTML(amp, (RC.cat || "Tratamiento intensivo"), true) + '</div>';
          grid.appendChild(block);
        });
        return;
      }
      // step block (1 o más productos)
      stepNo++;
      var num = String(stepNo);
      if (num.length < 2) num = "0" + num;
      var cards = blk.ids.map(function (id) { return productCardHTML(prod(id), blk.role, false); }).join("");
      blk.ids.forEach(function (id) { var pp = prod(id); if (pp && pp.available) total += (pp.priceCents || 0); });
      var sb = document.createElement("div");
      sb.className = "step-block";
      sb.innerHTML =
        '<div class="step-head">' +
          '<span class="step-no-lbl">Paso ' + num + '</span>' +
          '<h4 class="step-title">' + stepTitle(blk.role) + '</h4>' +
          '<p class="step-mini">' + stepCopy(blk.role) + '</p>' +
        '</div>' +
        '<div class="step-products">' + cards + '</div>';
      grid.appendChild(sb);
    });

    // sumar ampollas tildadas al total
    recommendedAmpoules().forEach(function (v) {
      if (!ampSelected(v.key)) return;
      var a = prod(v.id);
      if (a && a.available) total += (a.priceCents || 0);
    });

    // checkboxes de ampollas -> state + total refresh
    $$('#product-grid .reco-check input[data-amp]').forEach(function (inp) {
      inp.addEventListener("change", function () {
        state.ampSel[inp.getAttribute("data-amp")] = inp.checked;
        save();
        refreshSummary();
      });
    });

    wireGalleries();
    wireAccordions();
    refreshSummary();

    var cb = $("#cart-btn");
    cb.classList.remove("is-loading", "is-done");
    cb.querySelector(".cart-lbl").textContent = cfgUi("cartLabel", "Comprar Ahora");
  }

  function collectVariantIds() {
    var data = buildBlocks();
    var ids = [];
    data.ritual.steps.forEach(function (step) {
      step.ids.forEach(function (id) {
        var p = prod(id);
        if (p && p.available && p.variantId) ids.push(p.variantId);
      });
    });
    recommendedAmpoules().forEach(function (v) {
      if (!ampSelected(v.key)) return;
      var amp = prod(v.id);
      if (amp && amp.available && amp.variantId) ids.push(amp.variantId);
    });
    return ids;
  }

  function refreshSummary() {
    var ids = collectVariantIds();
    var total = 0;
    var data = buildBlocks();
    data.ritual.steps.forEach(function (s) { s.ids.forEach(function (id) { var p = prod(id); if (p && p.available) total += (p.priceCents || 0); }); });
    recommendedAmpoules().forEach(function (v) { if (!ampSelected(v.key)) return; var amp = prod(v.id); if (amp && amp.available) total += (amp.priceCents || 0); });
    var sum = $("#cart-summary");
    sum.classList.remove("cart-error");
    var sumTpl = cfgUi("summaryTpl", "{n} productos · Ritual completo AM · PM — total {total}");
    sum.innerHTML = sumTpl.replace("{n}", ids.length).replace("{total}", money(total));
  }

  /* ---------------------------------------------------------
     GALLERIES + ACCORDIONS
     --------------------------------------------------------- */
  function wireGalleries() {
    $$("#product-grid .p-gallery").forEach(function (g) {
      var track = g.querySelector(".p-track");
      var dots = $$(".g-dots i", g);
      var count = track.children.length;
      var idx = 0;
      function render() {
        track.style.transform = "translateX(" + (-idx * 100) + "%)";
        dots.forEach(function (d, i) { d.classList.toggle("on", i === idx); });
      }
      function nudge(dir) { idx = Math.max(0, Math.min(count - 1, idx + dir)); render(); }
      var prevB = g.querySelector(".prev"), nextB = g.querySelector(".next");
      if (prevB) prevB.addEventListener("click", function () { nudge(-1); });
      if (nextB) nextB.addEventListener("click", function () { nudge(1); });
      var sx = 0, sy = 0, swiping = false, locked = null;
      g.addEventListener("pointerdown", function (e) {
        if (e.target.closest(".g-arrow")) return;
        swiping = true; locked = null; sx = e.clientX; sy = e.clientY;
      });
      g.addEventListener("pointermove", function (e) {
        if (!swiping) return;
        var dx = e.clientX - sx, dy = e.clientY - sy;
        if (locked === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) locked = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
        if (locked === "x") {
          e.preventDefault();
          track.style.transition = "none";
          var pct = (dx / g.offsetWidth) * 100;
          track.style.transform = "translateX(" + (-idx * 100 + pct) + "%)";
        }
      });
      function endSwipe(e) {
        if (!swiping) return;
        swiping = false;
        track.style.transition = "";
        if (locked === "x") {
          var dx = e.clientX - sx;
          if (Math.abs(dx) > g.offsetWidth * 0.18) nudge(dx < 0 ? 1 : -1);
          else render();
        }
        locked = null;
      }
      g.addEventListener("pointerup", endSwipe);
      g.addEventListener("pointercancel", endSwipe);
      render();
    });
  }
  function wireAccordions() {
    $$("#product-grid .acc-toggle").forEach(function (btn) {
      var panel = btn.nextElementSibling;
      var inner = panel.querySelector(".acc-inner");
      var open = false;
      btn.addEventListener("click", function () {
        open = !open;
        btn.classList.toggle("open", open);
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        btn.querySelector(".acc-lbl").textContent = open ? "Ocultar descripción" : "Ver descripción";
        clearTimeout(panel._t);
        setTimeout(updateScrollHint, 450);
        if (open) {
          panel.style.height = inner.scrollHeight + "px";
          panel._t = setTimeout(function () { if (open) panel.style.height = "auto"; }, 430);
        } else {
          panel.style.height = panel.getBoundingClientRect().height + "px";
          void panel.offsetHeight;
          panel.style.height = "0px";
          panel._t = setTimeout(function () {
            if (!open) { var ts = panel.style.transition; panel.style.transition = "none"; panel.style.height = "0px"; void panel.offsetHeight; panel.style.transition = ts; }
          }, 430);
        }
      });
    });
  }

  /* ---------------------------------------------------------
     CART (AJAX)
     --------------------------------------------------------- */
  function addToCart() {
    var cb = $("#cart-btn");
    if (cb.classList.contains("is-loading") || cb.classList.contains("is-done")) return;
    var ids = collectVariantIds();
    var sum = $("#cart-summary");
    if (!ids.length) {
      sum.classList.add("cart-error");
      sum.textContent = "No hay productos disponibles para agregar.";
      return;
    }
    cb.classList.add("is-loading");
    cb.querySelector(".cart-lbl").textContent = cfgUi("cartAdding", "Agregando");
    cb.querySelector(".cart-ic").innerHTML = '<span class="spin"></span>';

    var items = ids.map(function (id) { return { id: id, quantity: 1 }; });
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items })
    })
    .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
    .then(function () {
      var after = ROOT.getAttribute("data-after") || "checkout";
      // Redirecciones: instantáneas, sin pasos extra
      if (after === "checkout") { window.location.href = "/checkout"; return; }
      if (after === "cart")     { window.location.href = "/cart"; return; }
      // after === "drawer": abrir YA (sin esperar /cart.js); refrescar en background
      cb.classList.remove("is-loading");
      cb.classList.add("is-done");
      cb.querySelector(".cart-lbl").textContent = cfgUi("cartDone", "¡Agregado al carrito!");
      cb.querySelector(".cart-ic").innerHTML = I.checkOnly;
      openCartDrawer();
      refreshThemeCart();
    })
    .catch(function (err) {
      cb.classList.remove("is-loading");
      cb.querySelector(".cart-lbl").textContent = cfgUi("cartLabel", "Comprar Ahora");
      cb.querySelector(".cart-ic").innerHTML = I.bag;
      sum.classList.add("cart-error");
      sum.textContent = (err && err.description) ? err.description : "No se pudo agregar al carrito. Reintentá.";
    });
  }
  // Refresca el contador/contenido del cart-drawer del tema sin recargar
  function refreshThemeCart() {
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        ["cart:refresh", "cart:updated", "cart:change", "cart:build"].forEach(function (name) {
          document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart } }));
        });
        // Horizon: intentar que el cart-items-component vuelva a renderizar
        var ci = document.querySelector("cart-items-component");
        ["requestUpdate", "refresh", "renderContents", "fetchCart", "updateCart"].forEach(function (m) {
          if (ci && typeof ci[m] === "function") { try { ci[m](); } catch (e) {} }
        });
        if (window.Shopify && window.Shopify.onCartUpdate) { try { window.Shopify.onCartUpdate(cart); } catch (e) {} }
        return cart;
      })
      .catch(function () {});
  }
  // Abre el cart-drawer de Horizon. Fallbacks: trigger nativo, luego /cart.
  function openCartDrawer() {
    var cd = document.querySelector("cart-drawer-component, cart-drawer");
    if (cd && typeof cd.open === "function") { try { cd.open(); return; } catch (e) {} }
    var trig = document.querySelector('[data-testid="cart-drawer-trigger"], #cart-icon-bubble, [on\\:click="/open"]');
    if (trig) { trig.click(); return; }
    window.location.href = "/cart";
  }

  /* ---------------------------------------------------------
     SCROLL HINT
     --------------------------------------------------------- */
  function activeScroller() {
    var scr = $('.screen[data-screen="' + state.screen + '"]');
    if (!scr) return null;
    return scr.querySelector(".screen-body, .results-scroll, .hero");
  }
  function bottomBarHeight() {
    if (state.screen === "results") { var a = $(".results-action"); return a ? a.offsetHeight : 0; }
    if (state.screen in STEP_NUM) { var f = $("#footer"); return (f && !f.classList.contains("hidden")) ? f.offsetHeight : 0; }
    return 0;
  }
  function updateScrollHint() {
    var el = activeScroller();
    var hint = $("#scroll-hint");
    if (!el || !hint) { ROOT.classList.remove("can-scroll"); return; }
    var more = el.scrollHeight - el.clientHeight - el.scrollTop > 40;
    ROOT.classList.toggle("can-scroll", more);
    if (more) hint.style.setProperty("--hint-bottom", (bottomBarHeight() + 16) + "px");
  }
  function wireScrollHint() {
    ROOT.addEventListener("scroll", updateScrollHint, true);
    window.addEventListener("resize", updateScrollHint);
    $("#scroll-hint").addEventListener("click", function () {
      var el = activeScroller();
      if (el) el.scrollBy({ top: el.clientHeight * 0.7, behavior: "smooth" });
    });
  }

  /* ---------------------------------------------------------
     RESTART
     --------------------------------------------------------- */
  function restart() {
    var from = state.screen;
    state = defaultState();
    state.screen = from;
    save();
    refreshGroup("age"); refreshGroup("skinType"); refreshGroup("skinChar"); refreshGroup("benefits");
    resetTemp();
    go("hero", -1);
  }

  /* ---------------------------------------------------------
     INIT
     --------------------------------------------------------- */
  function injectIcons() {
    $("#btn-continue .ic").innerHTML = I.arrowR;
    $("#btn-back .ic").innerHTML = I.arrowL;
    $("#hero-start .ic").innerHTML = I.arrowR;
    var help = $("#help-btn"); if (help) help.insertAdjacentHTML("afterbegin", I.help);
    $("#drawer-close").innerHTML = I.close;
    $("#cart-btn .cart-ic").innerHTML = I.bag;
    $("#redo-btn .ic").innerHTML = I.redo;
    var rt = $("#redo-top .ic"); if (rt) rt.innerHTML = I.redo;
    var sh = $("#scroll-hint .ic"); if (sh) sh.innerHTML = I.chevron;
    $$("#drawer .skin-note .ic").forEach(function (el, i) { el.innerHTML = [I.droplet, I.sun, I.leaf][i] || I.droplet; });
  }
  function wire() {
    buildSingle("#age-options", "age", AGES, { field: "age", deselectable: true });
    buildSingle("#skin-options", "skinType", SKIN_TYPES, { field: "skinType", tri: true });
    buildSingle("#char-options", "skinChar", SKIN_CHARS, { field: "skinChar", deselectable: true });
    buildSingle("#benefit-options", "benefits", BENEFITS, { field: "benefits", multi: true, max: BENEFIT_MAX });
    wireTemp();
    $("#hero-start").addEventListener("click", function () { go("step1"); });
    $("#btn-continue").addEventListener("click", function () { if (isValid(state.screen)) go(nextOf(state.screen)); });
    $("#btn-back").addEventListener("click", function () { go(prevOf(state.screen), -1); });
    var help = $("#help-btn"); if (help) help.addEventListener("click", openDrawer);
    $("#drawer-close").addEventListener("click", closeDrawer);
    $("#drawer-ok").addEventListener("click", closeDrawer);
    $("#scrim").addEventListener("click", closeDrawer);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });
    $("#cart-btn").addEventListener("click", addToCart);
    $("#redo-btn").addEventListener("click", restart);
    $("#restart-top").addEventListener("click", restart);
    $("#redo-top").addEventListener("click", restart);
    wireScrollHint();
  }

  function init() {
    injectIcons();
    wire();
    var restore = (state.screen in STEP_NUM || state.screen === "results") ? state.screen : "hero";
    $('.screen[data-screen="' + restore + '"]').classList.add("active");
    state.screen = restore;
    ROOT.setAttribute("data-screen", restore);
    syncChrome();
    if (restore === "results") buildResults();
    setTimeout(updateScrollHint, 120);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
